import { isNonProductionEnvironment } from "@/utils/isNonProductionEnvironment";

/**
 * Whether the iframe parent test harness route is allowed.
 * Blocked on production hosts; enabled for local dev, test/staging hosts, or explicit env flag.
 */
export function isIframeTestHarnessEnabled(): boolean {
  if (process.env.VUE_APP_ENABLE_IFRAME_TEST_HARNESS === "true") {
    return true;
  }
  return isNonProductionEnvironment();
}
